const en = {
  searchOrCreate: 'Search or create...',
  createOption: '+ Create "{{value}}"',
};

const de = {
  searchOrCreate: 'Suchen oder erstellen...',
  createOption: '+ "{{value}}" erstellen',
};

const searchCreateSelect = { en, de };
export default searchCreateSelect;
